export default {
    ACCESS_TOKEN: 'token',
    REFRESH_TOKEN: 'refresh_token',
    ACCELERATOR_ID: 'accelerator',
} as const;
